<template>
  <div>
    <v-menu offset-y open-on-hover>
      <template v-slot:activator="{ on }">
        <v-btn class="extra-small" color="primary" fab outline v-on="on">
          <span class="fas fa-ellipsis-v"></span>
        </v-btn>
      </template>
      <v-list>
        <v-list-tile v-for="(item, index) in items" :key="index" @click="insertPrefill(item.value)">
          <v-list-tile-title class="primary-color">{{ item.title }}</v-list-tile-title>
        </v-list-tile>
      </v-list>
    </v-menu>
  </div>
</template>

<script>
export default {
  data: function() {
    return {
      items: [
        {
          title: this.$t('Number'),
          value: '{number}'
        }
      ]
    }
  },
  methods: {
    insertPrefill: function(value) {
      this.$emit('onAddPrefill', value)
    }
  }
}
</script>

<style lang="scss" scoped>
</style>


// WEBPACK FOOTER //
// src/components/elements/IntentPrefillCartAddRemove.vue